import {
        AlarmControlPanelCommandTypes
} from "../../constans/mqttMessages";

const mappedToStateMessages = {
        [AlarmControlPanelCommandTypes.GET_HMIS_CONFIGURATION]: true,
}

export default (command) => mappedToStateMessages[command] ?? false;